// Live Server
export const baseURL = "https://appraisal.omansats.om/api";
// export const baseURL = "https://appraisal.transomcargo.om/api";

// const localApiPort = process.env.REACT_APP_API_PORT || "5000";

// export const baseURL =
//   process.env.REACT_APP_API_URL || `http://localhost:${localApiPort}`;
// export const baseURL = "http://192.168.29.213:8080";

// export const baseURL = "https://appraisaltest.agilityglobal.net/api";

// Test Server
// export const baseURL = "http://62.171.132.102:8080";

// Haitham.AlHinai@omansats.om
// Oman sats1234

// TEST SERVER LOCATION
// Node - /root/ams/nodeservices/ ------ (only server.js to replace restart pm2)
// React - /root/ams/react/ ------ (open src inside zip the folder)

// LIVE SERVER LOCATION
// Node - /var/www/oman-node ---- (only server.js to replace  restart pm2)
// React - /var/www/html  --- (rename build to appraisal-react)---and rename old build to date
